<template>
	<div class="bg-gray-950 h-screen w-full text-gray-400 p-32">
		<div class="grid grid-cols-2 gap-10 h-full">
			<div class="border rounded border-gray-800 h-full flex items-center justify-center p-5 relative">
				<div class="absolute bottom-0 w-full h-60 p-10">
					<section>

					</section>
				</div>
				<svg id="ezt4qFb68ku1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 691 814" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
				<g id="Group 1">
				<path id="water" :transform="`translate(0, ${waterPosition})`" fill-rule="evenodd" clip-rule="evenodd" d="M37 505.75C41.577 507.625 46.154 509.5 52.5 509.5C59.0413 509.5 64.5206 507.625 70 505.75C75.4794 503.875 80.9587 502 87.5 502C92.7721 502 98.511 503.125 104.25 504.25C109.989 505.375 115.728 506.5 121 506.5C129.689 506.5 134.345 504.875 139 503.25C143.655 501.625 148.311 500 157 500C161.393 500 165.447 502 169.5 504C173.553 506 177.607 508 182 508C187.37 508 191.435 506.5 195.5 505C199.565 503.5 203.63 502 209 502C215.932 502 221.466 503.5 227 505C232.534 506.5 238.068 508 245 508C251.444 508 256.347 506.875 261.25 505.75C266.153 504.625 271.056 503.5 277.5 503.5C284.237 503.5 289.368 504.625 294.5 505.75C299.632 506.875 304.763 508 311.5 508C318.627 508 324.189 505.875 329.75 503.75C335.311 501.625 340.873 499.5 348 499.5C353.663 499.5 358.206 501.625 362.75 503.75C367.294 505.875 371.837 508 377.5 508C384.237 508 389.493 506.5 394.75 505C400.007 503.5 405.263 502 412 502C416.784 502 420.517 504 424.25 506C427.983 508 431.716 510 436.5 510C443.627 510 449.189 508 454.75 506C460.311 504 465.873 502 473 502C478.37 502 481.935 503.5 485.5 505C489.065 506.5 492.63 508 498 508C505.225 508 509.862 505.875 514.5 503.75C519.138 501.625 523.775 499.5 531 499.5C534.71 499.5 539.23 501.625 543.75 503.75C548.27 505.875 552.79 508 556.5 508C560.112 508 562.931 506.5 565.75 505C568.569 503.5 571.388 502 575 502C581.151 502 585.825 503.5 590.5 505C595.175 506.5 599.849 508 606 508C612.248 508 617.249 506.5 622.25 505C627.251 503.5 632.252 502 638.5 502C643.87 502 648.435 503.5 653 505C657.565 506.5 662.13 508 667.5 508C671.405 508 674.078 506.5 676.75 505C678.112 504.235 679.474 503.471 681 502.905V800H11V497H19.3178L21.5 502C27.846 502 32.423 503.875 37 505.75Z" fill="url(#paint0_linear_23_46)"/>
				<path id="drat as" fill-rule="evenodd" clip-rule="evenodd" d="M348 97.0128H344V102.739L341 103.661V106.815L344 105.893V107.207L341 108.129V111.283L344 110.361V111.675L341 112.597V115.751L344 114.829V116.143L341 117.065V120.219L344 119.297V120.611L341 121.533V124.687L344 123.765V125.079L341 126.001V129.155L344 128.233V129.547L341 130.47V133.623L344 132.701V134.015L341 134.938V138.091L344 137.169V138.484L341 139.406V142.559L344 141.637V142.952L341 143.874V147.028L344 146.105V147.42L341 148.342V151.496L344 150.574V151.888L341 152.81V155.964L344 155.042V156.356L341 157.278V160.432L344 159.51V160.824L341 161.746V164.9L344 163.978V165.292L341 166.214V169.368L344 168.446V169.76L341 170.682V173.836L344 172.914V174.228L341 175.15V178.304L344 177.382V178.696L341 179.618V182.772L344 181.85V183.164L341 184.086V187.24L344 186.318V187.632L341 188.554V191.708L344 190.786V192.1L341 193.022V196.176L344 195.254V196.568L341 197.49V200.644L344 199.722V201.036L341 201.958V205.112L344 204.19V205.504L341 206.427V209.58L344 208.658V209.972L341 210.895V214.048L344 213.126V214.441L341 215.363V218.516L344 217.594V218.909L341 219.831V222.985L344 222.062V223.377L341 224.299V227.453L344 226.531V227.845L341 228.767V231.921L344 230.999V232.313L341 233.235V236.389L344 235.467V236.781L341 237.703V240.857L344 239.935V241.249L341 242.171V245.325L344 244.403V245.717L341 246.639V249.793L344 248.871V250.185L341 251.107V254.261L344 253.339V254.653L341 255.575V258.729L344 257.807V259.121L341 260.043V263.197L344 262.275V263.589L341 264.511V267.665L344 266.743V268.057L341 268.979V272.133L344 271.211V272.525L341 273.447V276.601L344 275.679V276.993L341 277.916V281.069L344 280.147V281.461L341 282.384V285.537L344 284.615V285.93L341 286.852V290.005L344 289.083V290.398L341 291.32V294.474L344 293.551V294.866L341 295.788V298.942L344 298.019V299.334L341 300.256V303.41L344 302.488V303.802L341 304.724V307.878L344 306.956V308.27L341 309.192V312.346L344 311.424V312.738L341 313.66V316.814L344 315.892V317.206L341 318.128V321.282L344 320.36V321.674L341 322.596V325.75L344 324.828V326.142L341 327.064V330.218L344 329.296V330.61L341 331.532V334.686L344 333.764V335.078L341 336V339.154L344 338.232V339.546L341 340.468V343.622L344 342.7V344.014L341 344.936V348.09L344 347.168V348.482L341 349.404V352.558L344 351.636V352.95L341 353.873V357.026L344 356.104V357.419L341 358.341V361.494L344 360.572V361.887L341 362.809V365.962L344 365.04V366.355L341 367.277V370.431L344 369.508V370.823L341 371.745V374.899L344 373.977V375.291L341 376.213V379.367L344 378.445V379.759L341 380.681V383.835L344 382.913V384.227L341 385.149V388.303L344 387.381V388.695L341 389.617V392.771L344 391.849V393.163L341 394.085V397.239L344 396.317V397.631L341 398.553V401.707L344 400.785V402.099L341 403.021V406.175L344 405.253V406.567L341 407.489V410.643L344 409.721V411.035L341 411.957V415.111L344 414.189V415.503L341 416.425V419.579L344 418.657V419.971L341 420.893V424.047L344 423.125V424.439L341 425.361V428.515L344 427.593V428.907L341 429.83V432.983L344 432.061V433.376L341 434.298V437.451L344 436.529V437.844L341 438.766V441.919L344 440.997V442.312L341 443.234V446.388L344 445.465V446.78L341 447.702V450.856L344 449.934V451.248L341 452.17V455.324L344 454.402V455.716L341 456.638V459.792L344 458.87V460.184L341 461.106V464.26L344 463.338V464.652L341 465.574V468.728L344 467.806V469.12L341 470.042V473.196L351 470.122V466.968L348 467.891V466.576L351 465.654V462.5L348 463.422V462.108L351 461.186V458.032L348 458.954V457.64L351 456.718V453.564L348 454.486V453.172L351 452.25V449.096L348 450.018V448.704L351 447.782V444.628L348 445.55V444.236L351 443.314V440.16L348 441.082V439.768L351 438.846V435.692L348 436.614V435.3L351 434.378V431.224L348 432.146V430.832L351 429.91V426.756L348 427.678V426.364L351 425.442V422.288L348 423.21V421.896L351 420.974V417.82L348 418.742V417.428L351 416.506V413.352L348 414.274V412.96L351 412.037V408.884L348 409.806V408.492L351 407.569V404.416L348 405.338V404.023L351 403.101V399.948L348 400.87V399.555L351 398.633V395.479L348 396.402V395.087L351 394.165V391.011L348 391.933V390.619L351 389.697V386.543L348 387.465V386.151L351 385.229V382.075L348 382.997V381.683L351 380.761V377.607L348 378.529V377.215L351 376.293V373.139L348 374.061V372.747L351 371.825V368.671L348 369.593V368.279L351 367.357V364.203L348 365.125V363.811L351 362.889V359.735L348 360.657V359.343L351 358.421V355.267L348 356.189V354.875L351 353.953V350.799L348 351.721V350.407L351 349.485V346.331L348 347.253V345.939L351 345.017V341.863L348 342.785V341.471L351 340.549V337.395L348 338.317V337.003L351 336.08V332.927L348 333.849V332.535L351 331.612V328.459L348 329.381V328.066L351 327.144V323.99L348 324.913V323.598L351 322.676V319.522L348 320.445V319.13L351 318.208V315.054L348 315.976V314.662L351 313.74V310.586L348 311.508V310.194L351 309.272V306.118L348 307.04V305.726L351 304.804V301.65L348 302.572V301.258L351 300.336V297.182L348 298.104V296.79L351 295.868V292.714L348 293.636V292.322L351 291.4V288.246L348 289.168V287.854L351 286.932V283.778L348 284.7V283.386L351 282.464V279.31L348 280.232V278.918L351 277.996V274.842L348 275.764V274.45L351 273.528V270.374L348 271.296V269.982L351 269.06V265.906L348 266.828V265.514L351 264.592V261.438L348 262.36V261.046L351 260.123V256.97L348 257.892V256.577L351 255.655V252.502L348 253.424V252.109L351 251.187V248.033L348 248.956V247.641L351 246.719V243.565L348 244.488V243.173L351 242.251V239.097L348 240.019V238.705L351 237.783V234.629L348 235.551V234.237L351 233.315V230.161L348 231.083V229.769L351 228.847V225.693L348 226.615V225.301L351 224.379V221.225L348 222.147V220.833L351 219.911V216.757L348 217.679V216.365L351 215.443V212.289L348 213.211V211.897L351 210.975V207.821L348 208.743V207.429L351 206.507V203.353L348 204.275V202.961L351 202.039V198.885L348 199.807V198.493L351 197.571V194.417L348 195.339V194.025L351 193.103V189.949L348 190.871V189.557L351 188.634V185.481L348 186.403V185.089L351 184.166V181.013L348 181.935V180.62L351 179.698V176.545L348 177.467V176.152L351 175.23V172.076L348 172.999V171.684L351 170.762V167.608L348 168.53V167.216L351 166.294V163.14L348 164.062V162.748L351 161.826V158.672L348 159.594V158.28L351 157.358V154.204L348 155.126V153.812L351 152.89V149.736L348 150.658V149.344L351 148.422V145.268L348 146.19V144.876L351 143.954V140.8L348 141.722V140.408L351 139.486V136.332L348 137.254V135.94L351 135.018V131.864L348 132.786V131.472L351 130.55V127.396L348 128.318V127.004L351 126.082V122.928L348 123.85V122.536L351 121.614V118.46L348 119.382V118.068L351 117.146V113.992L348 114.914V113.6L351 112.677V109.524L348 110.446V109.131L351 108.209V105.056L348 105.978V104.663L351 103.741V100.588L348 101.51V97.0128Z" fill="url(#paint1_linear_23_46)"/>
				<path id="pintu" :transform="`translate(0, ${doorPosition})`" fill-rule="evenodd" clip-rule="evenodd" d="M360 456H330V469.013H201V800.013H491V469.013H360V456Z" fill="url(#paint2_linear_23_46)"/>
				<path id="frame" fill-rule="evenodd" clip-rule="evenodd" d="M364 125.013H327V140.013H201V800.013H491V140.013H364V125.013ZM327 150.013H211V790.013H481V150.013H364H327Z" fill="#3358DC"/>
				<g :class="[{'bowtie':pushUp}, {'bowtiedown': pushDown}]">
				<path id="handler" fill-rule="evenodd" clip-rule="evenodd" d="M288.835 190.526L307.438 158.304C287.305 145.947 273.716 124.079 273.027 99.0128H236V94.0128H273.062C274.086 69.1892 287.766 47.6074 307.865 35.4612L288.835 2.5L293.165 0L312.231 33.0239C322.195 27.9044 333.508 25.0128 345.5 25.0128C357.802 25.0128 369.388 28.0556 379.537 33.4247L398.835 0L403.165 2.5L383.874 35.9137C403.568 48.1388 416.926 69.4946 417.938 94.0128H456V99.0128H417.973C417.293 123.773 404.026 145.412 384.298 157.847L403.165 190.526L398.835 193.026L379.979 160.365C369.725 165.881 357.981 169.013 345.5 169.013C333.329 169.013 321.858 166.034 311.787 160.771L293.165 193.026L288.835 190.526ZM382.796 155.246C401.629 143.333 414.293 122.663 414.971 99.0128H356.727C356.243 101.2 355.135 103.153 353.6 104.676L382.796 155.246ZM349.368 107.346L378.478 157.766C368.665 163.027 357.434 166.013 345.5 166.013C333.876 166.013 322.918 163.179 313.289 158.17L342.479 107.612C343.442 107.873 344.454 108.013 345.5 108.013C346.857 108.013 348.159 107.778 349.368 107.346ZM342.479 85.4138C343.442 85.1523 344.454 85.0128 345.5 85.0128C346.857 85.0128 348.159 85.2479 349.368 85.6795L378.036 36.0251C368.329 30.9103 357.255 28.0128 345.5 28.0128C334.054 28.0128 323.255 30.7597 313.734 35.6258L342.479 85.4138ZM309.366 38.0602L338.053 87.749C336.18 89.3425 334.824 91.5263 334.273 94.0128H276.065C277.086 70.2995 290.163 49.6862 309.366 38.0602ZM308.939 155.705L338.053 105.277C336.18 103.683 334.824 101.499 334.273 99.0128H276.029C276.715 122.969 289.702 143.868 308.939 155.705ZM356.727 94.0128C356.243 91.8255 355.135 89.8725 353.6 88.3494L382.373 38.5135C401.171 50.2173 413.927 70.6047 414.935 94.0128H356.727Z" fill="#2D81FF"/>
				</g>
				<path transform="translate(0, 1.8)" id="beton" fill-rule="evenodd" clip-rule="evenodd" d="M20 467H0V814H690V467H670V789.791H20V467Z" fill="#D9D9D9"/>
				<g id="water level">
				<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M580.375 388C579.823 388 579.375 388.448 579.375 389V396.235H577C576.448 396.235 576 396.683 576 397.235V415C576 415.552 576.448 416 577 416H602C602.552 416 603 415.552 603 415V397.235C603 396.683 602.552 396.235 602 396.235H599.625V389C599.625 388.448 599.177 388 598.625 388H580.375Z" fill="url(#paint3_linear_23_46)"/>
				<line id="Line 1" x1="589.5" y1="390" x2="589.5" y2="314" stroke="#D9D9D9"/>
				<g id="signal">
					<g>
					<path class="signal-1" id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M599.435 429.549C596.788 431.357 593.588 432.413 590.141 432.413C586.359 432.413 582.874 431.141 580.09 429L578.666 430.425C581.819 432.922 585.806 434.413 590.141 434.413C594.142 434.413 597.845 433.144 600.872 430.985L599.435 429.549Z" fill="#D9D9D9"/>
					<path class="signal-2" id="Subtract_2" fill-rule="evenodd" clip-rule="evenodd" d="M603.732 437.846C599.957 440.713 595.248 442.413 590.141 442.413C584.701 442.413 579.712 440.483 575.821 437.269L574.401 438.689C578.659 442.262 584.149 444.413 590.141 444.413C595.8 444.413 601.011 442.495 605.159 439.273L603.732 437.846Z" fill="#D9D9D9"/>
					<path class="signal-3" id="Subtract_3" fill-rule="evenodd" clip-rule="evenodd" d="M607.699 444.813C602.824 448.931 596.523 451.413 589.641 451.413C582.682 451.413 576.316 448.875 571.418 444.672L570 446.09C575.263 450.653 582.13 453.413 589.641 453.413C597.075 453.413 603.877 450.71 609.118 446.232L607.699 444.813Z" fill="#D9D9D9"/>
					</g>
				</g>
				<g>
					<rect id="Rectangle 26" x="526" y="248" width="165" height="66" rx="11" fill="#D9D9D9"/>
					<text id="1200.56"  fill="black" xml:space="preserve" style="white-space: pre"  font-size="32" font-weight="bold" letter-spacing="0em" text-anchor="middle" x="608" y="292.136">{{level}}</text>
					<text id="WATER LEVEL" fill="white" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0em"><tspan x="550" y="238.455">WATER LEVEL</tspan></text>
				</g>
				</g>
				<g id="sensor ph">
					<rect id="Rectangle 26_2" x="1" y="248" width="165" height="66" rx="11" fill="#D9D9D9"/>
					<text id="1200.56_2" fill="black" xml:space="preserve" style="white-space: pre" font-size="32" font-weight="bold" letter-spacing="0em" text-anchor="middle"><tspan x="84" y="292.136">{{ph}}</tspan></text>
					<text id="SENSOR PH" fill="white" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0em"><tspan x="32" y="238.455">SENSRO PH</tspan></text>
					<line id="Line 2" x1="110.5" y1="314" x2="110.5" y2="654" stroke="white"/>
					<rect id="Rectangle 27" x="102" y="654" width="18" height="51" fill="#D9D9D9"/>
				</g>
				</g>
				<defs>
				<linearGradient id="paint0_linear_23_46" x1="346" y1="497" x2="346" y2="800" gradientUnits="userSpaceOnUse">
				<stop stop-color="#71E9FA"/>
				<stop offset="1" stop-color="#018294"/>
				</linearGradient>
				<linearGradient id="paint1_linear_23_46" x1="346" y1="97.0128" x2="346" y2="473.196" gradientUnits="userSpaceOnUse">
				<stop stop-color="#323232"/>
				<stop offset="1" stop-color="#9C9999"/>
				</linearGradient>
				<linearGradient id="paint2_linear_23_46" x1="201" y1="572" x2="491" y2="572" gradientUnits="userSpaceOnUse">
				<stop stop-color="#2D81FF"/>
				<stop offset="0.5" stop-color="#5C9DFF"/>
				<stop offset="1" stop-color="#287EFF"/>
				</linearGradient>
				<linearGradient id="paint3_linear_23_46" x1="568.184" y1="407.236" x2="622.895" y2="407.236" gradientUnits="userSpaceOnUse">
				<stop offset="0.338542" stop-color="#D9D9D9"/>
				<stop offset="1" stop-color="#585757"/>
				</linearGradient>
				</defs>
				
				</svg>
			</div>

			<div class="border rounded border-gray-800 grid grid-rows-3">
				<div class="flex justify-between">
					<div class="p-5">
						<div class="border border-gray-700 p-3 rounded grid grid-cols-2 gap-5">
							<div class="text-center">
								<div class="text-xs mb-3">POMPA 1</div>
								<div :class="[pushbuttonPompa1 ? 'bg-green-400': 'bg-gray-500']" class="rounded-full flex items-center justify-center p-1">
									<button @click="pushbuttonPompa1 = !pushbuttonPompa1" :class="[pushbuttonPompa1? 'text-green-400' : 'text-gray-500']" class="bg-gray-700 h-12 w-12 rounded-full flex justify-center"><i class="icon-switch mt-2" style="font-size:28px"></i></button>
								</div>
							</div>
							<div class="text-center">
								<div class="text-xs mb-3">POMPA 2</div>
								<div class="bg-gray-500 rounded-full flex items-center justify-center p-1">
									<button class="bg-gray-700 h-12 w-12 rounded-full flex justify-center text-gray-500"><i class="icon-switch mt-2" style="font-size:28px"></i></button>
								</div>
							</div>
						</div>
					</div>
					<div class="p-5">
						<div class="border border-gray-700 p-3 rounded">
							<div class="text-center">
								<div class="text-xs mb-3">DOSING PUMP</div>
								<div class="bg-gray-500 rounded-full inline-flex items-center justify-center p-1">
									<button class="bg-gray-700 h-12 w-12 rounded-full flex justify-center text-gray-500"><i class="icon-switch mt-2" style="font-size:28px"></i></button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center flex flex-col items-center justify-center">
					<div class="mb-5">PINTU AIR</div>
					<div class="grid grid-cols-2 gap-10">
						<div>
							<div class="mb-3 text-xs">TOMBOL BUKA</div>
							<div class="h-32 w-32 border rounded border-gray-800 flex items-center justify-center">
								<div class="border-4 border-green-600 p-1 rounded-full flex items-center justify-center">
									<button id="pushup" @mouseup="onMouseUpPushUp" @mousedown="onMouseDownPushUp" class="h-20 w-20 rounded-full shadow-inner drop-shadow-md shadow-green-800" :class="[pushUp ? 'bg-green-400':'bg-green-700']"></button>
								</div>
							</div>
						</div>
						<div>
							<div class="mb-3 text-xs">TOMBOL TUTUP</div>
							<div class="h-32 w-32 border rounded border-gray-800 flex items-center justify-center">
								<div class="border-4 border-red-600 p-1 rounded-full flex items-center justify-center">
									<button @mouseup="onMouseUpPushDown" @mousedown="onMouseDownPushDown" class="h-20 w-20 rounded-full shadow-inner drop-shadow-md shadow-red-800" :class="[pushDown ? 'bg-red-400':'bg-red-700']"></button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as mqtt from 'mqtt/dist/mqtt.min'
export default {
	data () {
		return {
			waterPosition: 0,
			doorPosition: 0,
			pushUp: false,
			pushDown: false,
			timer: '',
			client: '',
			switchup: '0',
			switchdown: '0',
			pushbuttonup: '0',
			pushbuttondown: '0',
			pushbuttonPompa1: false,
			pushbuttonPompa12: false,
			pushbuttonDossing: false,
			level: 0,
			ph: 0.00,
		}
	},
	mounted () {
		document.getElementById('pushup').addEventListener("touchstart", this.onMouseDownPushUp)
		document.getElementById('pushup').addEventListener("touchend", this.onMouseUpPushUp)
		this.client = mqtt.connect('wss://mqtt.ndpteknologi.com:8084/mqtt', {
            username: 'ndp',
            password: 'pwlan123'
        })
		this.client.subscribe(['ndp/switchup','ndp/switchdown', 'ndp/pushbuttonup', 'ndp/pushbuttondown', 'ndp/level', 'ndp/ph'])
		this.client.on('message', (topic, message) => {
			if(topic == 'ndp/switchup') {
				this.switchup = message.toString()
			}
			if(topic == 'ndp/switchdown') {
				this.switchdown = message.toString()
			}
			if(topic == 'ndp/pushbuttonup') {
				this.pushbuttonup = message.toString()
			}
			if(topic == 'ndp/pushbuttondown') {
				this.pushbuttondown = message.toString()
			}
			if(topic =='ndp/level') {
				this.level = message.toString();
			}
			if(topic == 'ndp/ph') {
				this.ph = message.toString();
			}
		})
		
		setInterval(this.createBubble , 50)
	},
	methods: {
		createBubble () {
			const section = document.querySelector('section')
			const createElement =  document.createElement('span')
			var size = Math.random() * 20
			createElement.style.width = size + 'px'
			createElement.style.height = size + 'px'
			createElement.style.left = Math.random() * section.offsetWidth + 'px'
			section.appendChild(createElement)
			setTimeout(() => {
				createElement.remove()
			}, 2000)
		},
		onMouseDownPushUp () {
			if(this.switchup != "1") {
				this.pushUp = true
				this.client.publish('ndp/relay/1', "0", 2)
			}
		},
		onMouseUpPushUp () {
			this.pushUp = false
			this.client.publish('ndp/relay/1', "1", 2)
		},
		onMouseDownPushDown () {
			if(this.switchdown != "1") {
				this.pushDown = true
				this.client.publish('ndp/relay/2', "0", 2)
			}
		},
		onMouseUpPushDown () {
			this.pushDown = false
			this.client.publish('ndp/relay/2', "1", 2)
		}
	},
	watch: {
		level (val) {
			this.waterPosition = parseInt(val) -80
		},
		switchup (val) {
			if(val == "1") {
				this.pushUp = false
				this.doorPosition = -109
			}
		},
		switchdown (val) {
			if(val == "1") {
				this.pushDown = false
				this.doorPosition = 0
			}
		},
		pushbuttonPompa1 (val) {
			if(val) {
				this.client.publish('ndp/relay/3', "1", 2)
			} else {
				this.client.publish('ndp/relay/3', "0", 2)
			}
		},
		pushbuttonup (val) {
			if(val == "0" && this.switchup != "1") {
				this.pushUp = true
			} else {
				this.pushUp = false
			}
		},
		pushbuttondown (val) {
			if(val == "0" && this.switchdown != "1") {
				this.pushDown = true
			} else {
				this.pushDown = false
			}
		},
		position (val) {
			if(val <= 202.08728000000002) {
				this.pushUp = false
				clearInterval(this.timer)
			}
			if(val >= 376.08728) {
				this.pushDown = false
				clearInterval(this.timer)
			}
		},
		pushUp (val) {
			if(val) {
				this.timer = setInterval(() => {
					this.doorPosition -= 1
				}, 100);
			} else {
				clearInterval(this.timer)
			}
		},
		pushDown (val) {
			if(val) {
				this.timer = setInterval(() => {
					this.doorPosition += 1
				}, 100);
			} else {
				clearInterval(this.timer)
			}
		}
	}
}
</script>
<style>
@keyframes bowspin {
  0% {
    transform: rotate(0deg);
    transform-origin: center;
    transform-box: fill-box;
  }
  100% {
    transform: rotate(360deg);
    transform-origin: center;
    transform-box: fill-box;
  }
}
@keyframes pushdown {
  0% {
    transform: rotate(360deg);
    transform-origin: center;
    transform-box: fill-box;
  }
  100% {
    transform: rotate(0deg);
    transform-origin: center;
    transform-box: fill-box;
  }
}
.bowtie {
  -webkit-animation: bowspin 1.3s infinite;
  transform-origin: bottom center;
  animation: bowspin 1.5s infinite;
  animation-timing-function: linear;
}
@keyframes signal {
	0% {
		transform: translate(0px, 0px);
	}
	100% {
		transform: translate(0, 100px);
	}
}
.bowtiedown {
  -webkit-animation: pushdown 1.5s infinite;
  transform-origin: bottom center;
  animation: pushdown 1.5s infinite;
  animation-timing-function: linear;
}
.signal-1 {
	transform-origin: center;
	animation: signal 1.5s 1 infinite;
	-webkit-animation: signal 1.5s infinite;
	animation-delay: -0.1s;
	animation-timing-function: linear

}
.signal-2 {
	transform-origin: center;
	animation: signal 1.5s infinite;
	-webkit-animation: signal 1.5s infinite;
	animation-delay: -0.2s;
	animation-timing-function: linear;
}
.signal-3 {
	transform-origin: center;
	animation: signal 1.5s infinite;
	-webkit-animation: signal 1.5s infinite;
	animation-delay: -0.3s;
	animation-timing-function: linear
}

/* BUUBLE */
section {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
}
section span {
	position: absolute;
	bottom: -5px;
	background: transparent;
	border-radius: 50% ;
	pointer-events: none;
	box-shadow: inset 0 0  10px rgba(255, 255, 255, 0.5);
	animation: bubble 2s linear infinite;
}
section span:before {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	transform: scale(0.25) translate(-70%, -70%);
	background: radial-gradient(#fff, transparent);
	border-radius: 50%;
}
@keyframes bubble {
	0% {
		transform: translateY(0%);
		opacity: 1;
	}
	20% {
		transform: translateX(-50%);
		opacity: 1;
	}
	30% {
		transform: translateX(100%);
		opacity: 1;
	}
	100% {
		transform: translateY(-1000%);
		opacity: 0;
	}
}
</style>